import { buildWebflowHoverAlignCss } from '@/lib/webflow-poc/webflow-isolation';

export const WEBFLOW_NAV_WRAPPER_CLASS = 'w-webflow-nav-chrome';
export const WEBFLOW_NAV_WRAPPER_SELECTOR = `.${WEBFLOW_NAV_WRAPPER_CLASS}.${WEBFLOW_NAV_WRAPPER_CLASS}`;

/** Same ≥1440px dropdown hover padding fix as full-page Webflow content. */
export const WEBFLOW_NAV_HOVER_ALIGN_CSS = buildWebflowHoverAlignCss(
  WEBFLOW_NAV_WRAPPER_SELECTOR
);

/**
 * Soft isolation for the Webflow navbar island.
 *
 * IMPORTANT: do NOT use `all: revert` here. That resets layout (display,
 * position, margin, padding, flex, transform, left/top) to the user-agent
 * stylesheet and causes hover/dropdown menus to shift — Webflow's authored
 * layout CSS then fights TW/Chakra inconsistently on :hover / .w--open.
 *
 * Only cut typography/color inheritance from Tradewing; leave layout to Webflow.
 * Injected only inside WebflowNavChrome (feature flag + integrated +
 * WEBFLOW/WEBFLOW_NATIVE). Double-class scoped — never touches TW header.
 */
export const WEBFLOW_NAV_CHAKRA_ISOLATION_CSS = `
${WEBFLOW_NAV_WRAPPER_SELECTOR} {
  font-family: initial;
  font-size: initial;
  font-weight: initial;
  font-style: initial;
  line-height: initial;
  letter-spacing: initial;
  text-transform: initial;
  color: initial;
  background: transparent;
  width: 100%;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
}

${WEBFLOW_NAV_WRAPPER_SELECTOR},
${WEBFLOW_NAV_WRAPPER_SELECTOR} * {
  box-sizing: border-box;
}

/* Undo Chakra/link preflight on text only — never touch layout props. */
${WEBFLOW_NAV_WRAPPER_SELECTOR} :where(a, button, p, span, li, label, h1, h2, h3, h4, h5, h6) {
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  font-style: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  text-decoration: none;
  color: inherit;
}
`.trim();

/**
 * Extra isolation when keeping Webflow nav CSS as designed (WEBFLOW_NATIVE).
 * Ensures dropdowns/hovers are not clipped by TW header flex containers.
 */
export const WEBFLOW_NAV_NATIVE_LAYOUT_CSS = `
${WEBFLOW_NAV_WRAPPER_SELECTOR},
${WEBFLOW_NAV_WRAPPER_SELECTOR} #data-tradewing-nav,
${WEBFLOW_NAV_WRAPPER_SELECTOR} .w-nav,
${WEBFLOW_NAV_WRAPPER_SELECTOR} .w-nav-menu,
${WEBFLOW_NAV_WRAPPER_SELECTOR} .w-dropdown,
${WEBFLOW_NAV_WRAPPER_SELECTOR} .w-dropdown-list,
${WEBFLOW_NAV_WRAPPER_SELECTOR} [class*="nav"],
${WEBFLOW_NAV_WRAPPER_SELECTOR} [class*="dropdown"] {
  overflow: visible !important;
}
`.trim();

/**
 * Injected AFTER scoped Webflow CSS for WEBFLOW (theme-match) mode only —
 * not for WEBFLOW_NATIVE. Softens Webflow chrome to sit on the TW white header.
 *
 * Intentionally does NOT force position/z-index on .w-nav (that breaks
 * absolute hover/dropdown positioning). Utilities are portaled to document.body.
 */
export const WEBFLOW_NAV_THEME_MATCH_CSS = `
${WEBFLOW_NAV_WRAPPER_SELECTOR},
${WEBFLOW_NAV_WRAPPER_SELECTOR} :where(
  #data-tradewing-nav,
  .w-nav,
  .w-nav-brand,
  .w-nav-menu,
  .w-nav-button,
  .w-container,
  .navbar,
  .nav-bar,
  .nav,
  .navigation,
  .header,
  nav,
  header,
  [class*="navbar"],
  [class*="nav-bar"],
  [class*="navigation"]
) {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
}

/* Dynamic pages use a white TW header — Webflow often styles links white for dark bars. */
${WEBFLOW_NAV_WRAPPER_SELECTOR} :where(a, .w-nav-link, [class*="nav-link"]) {
  color: #000000 !important;
}

${WEBFLOW_NAV_WRAPPER_SELECTOR} :where(a, .w-nav-link, [class*="nav-link"]):hover,
${WEBFLOW_NAV_WRAPPER_SELECTOR} :where(a, .w-nav-link, [class*="nav-link"]):focus,
${WEBFLOW_NAV_WRAPPER_SELECTOR} :where(a, .w-nav-link, [class*="nav-link"]).w--current {
  color: #000000 !important;
}
`.trim();
